import * as React from 'react';
import { cn } from '@wwe-portal/ui/lib/lib';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const TextInput = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, ...props }, ref) => {
    return (
      <input
        className={cn(
          'text-text700 focus:text-text500 bg-back300 border-back300 visible-focus:outline-none placeholder-text700 focus:bg-back400 h-[calc(1.5em_+_1rem_+_2px)] w-full rounded-md border px-8 py-2 text-base placeholder:text-sm hover:border hover:border-solid hover:border-[#4f5794] focus:border focus:border-solid focus:border-[#4f5794] focus:outline-none',
          className
        )}
        ref={ref}
        {...props}
        type="text"
      />
    );
  }
);
TextInput.displayName = 'Input';

export { TextInput };
